import { useState } from 'react'
import ReportFixedTable from 'features/report/table/ReportFixedTable'
import ReportScrollableTable from 'features/report/table/ReportScrollableTable'
import classNames from 'classnames'
import MultiTable from 'components/table/MultiTable'
import {
  ReportColumnAdGroupName,
  ReportColumnBizChannelName,
  ReportColumnCampaignName,
  ReportColumnCampaignType,
  ReportColumnEndDate,
  ReportColumnStartDate,
} from 'features/report/common/ReportColumns'

const ReportAdGroupTable = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  return (
    <div className={classNames('table_wrap', { scroll_ing: isScrolled })}>
      <MultiTable.Container>
        <ReportFixedTable />
        <ReportScrollableTable
          caption="맞춤보고서 광고그룹 테이블"
          onIsScrolledChange={setIsScrolled}
          baseColumns={[
            ReportColumnCampaignType,
            ReportColumnCampaignName,
            ReportColumnAdGroupName,
            ReportColumnBizChannelName,
            ReportColumnStartDate,
            ReportColumnEndDate,
          ]}
        />
      </MultiTable.Container>
    </div>
  )
}

export default ReportAdGroupTable
